// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"372":"cc5242a4","435":"e41112e5","701":"920d9cac","730":"73be797a","768":"1a52f16b","778":"e41112e5"}[chunkId] + ".chunk.css";
};